import React from 'react';
import { toast, ToastOptions } from 'react-toastify';

import Alert from '../Alert';

// Supertype of react-toastify's own options: `title` is additional and optional, so every
// existing call site (which never passes it) keeps rendering the per-type default title from
// `Alert`'s `alertConfigMap`. Stripped below before forwarding to react-toastify, which has no
// `title` key of its own to collide with.
export type AdmanToastOptions = ToastOptions<{}> & { title?: string };

const admanToast = {
  ...toast,
  success: (content: string, options?: AdmanToastOptions | undefined): number | string => {
    const { title, ...toastOptions } = options ?? {};
    return toast.success(<Alert type={'success'} text={content} title={title} />, toastOptions);
  },
  error: (content: string, options?: AdmanToastOptions | undefined): number | string => {
    const { title, ...toastOptions } = options ?? {};
    return toast.error(<Alert type={'error'} text={content} title={title} />, toastOptions);
  },
  warning: (content: string, options?: AdmanToastOptions | undefined): number | string => {
    const { title, ...toastOptions } = options ?? {};
    return toast.warning(<Alert type={'warning'} text={content} title={title} />, toastOptions);
  },
  info: (content: string, options?: AdmanToastOptions | undefined): number | string => {
    const { title, ...toastOptions } = options ?? {};
    return toast.info(<Alert type={'info'} text={content} title={title} />, toastOptions);
  },
};

export default admanToast;
